import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Modal } from 'bootstrap';
import { SecondaryBtn } from '../../components/cta/index';
import styles from '../../styles/components/confirmation.module.scss';

export default function OverrideConfirmation(props) {
	const modalRef = useRef(null);
	const backdropRef = useRef(null);

	const _createBackdrop = () => {
		if (backdropRef.current) return;
		const bd = document.createElement('div');
		bd.className = 'modal-backdrop fade show';
		bd.dataset.owner = 'override';
		bd.style.zIndex = '1090';
		document.body.appendChild(bd);
		backdropRef.current = bd;
	};

	console.log('types_of', props.type);

	const _removeBackdrop = () => {
		backdropRef.current?.remove();
		backdropRef.current = null;

		// Also clean up any untagged orphan backdrops beyond the first one
		// (first one belongs to SIP modal — keep it)
		const allBackdrops = document.querySelectorAll('.modal-backdrop:not([data-owner])');
		allBackdrops.forEach((bd, index) => {
			if (index > 0) bd.remove(); // keep only the first untagged (SIP modal's)
		});
	};

	useEffect(() => {
		const el = document.getElementById("override-confirmation");
		if (!el) return;

		if (!props.show) return;

		// Clean up any stale state from previous open
		_removeBackdrop();
		Modal.getInstance(el)?.dispose();

		el.style.zIndex = "1100";
		modalRef.current = new Modal(el, { backdrop: false, keyboard: false });

		_createBackdrop();
		modalRef.current.show();

		const handleHidden = () => {
			_removeBackdrop();
			props.closeModal();
		};

		el.addEventListener('hidden.bs.modal', handleHidden, { once: true }); // once: true avoids stacking listeners

	}, [props.show]);

	const handleClose = () => {
		modalRef.current?.hide();
	};

	const handleConfirm = () => {
		modalRef.current?.hide();
		props.onConfirm();
	};

	const getMessage = () => {
		switch (props.type) {
			case "CREATE":
				return "A rebalance request is already pending approval. Do you want to override and create a new SIP fund?";
			case "EDIT":
				return "A rebalance request is already pending approval. Do you want to override and update the existing rebalance?";
			case "CANCEL":
				return "A rebalance request is already pending approval. Do you want to override and cancel the SIP?";
			case "MULTIPLE":
				return "A rebalance request is already pending approval. Do you want to override and apply multiple changes (create, edit and/or cancel)?";
			default:
				return "A rebalance request is already pending approval. Do you want to continue?";
		}
	};

	const modalMarkup = (
		<div
			className={`${styles.e_confirmation} modal fade`}
			id="override-confirmation"
			tabIndex="-1"
			style={{ zIndex: 1100 }}
		>
			<div className="modal-dialog modal-dialog-centered">
				<div className="modal-content">
					<div className="modal-header border-0">
						<button type="button" className="btn-close" onClick={handleClose} />
					</div>
					<div className="modal-body p-4 text-center">
						<h6 className="mb-3">Confirm Override</h6>
						<p className="mb-4">{getMessage()}</p>
						<div className="d-flex justify-content-center gap-3">
							<SecondaryBtn name="Yes, Proceed" handleClick={handleConfirm} />
							<SecondaryBtn
								name="Cancel"
								handleClick={handleClose}
								className={styles.e_cancel}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);

	return ReactDOM.createPortal(modalMarkup, document.body);
}